import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import RentalStatus from "../../enums/RentalStatus";
import DateUtil from "../../util/DateUtil";
import Roles from "../../enums/Roles";

class RentalsAdmin extends React.Component {
  getStatusBadgeClass(status) {
    switch (status) {
      case RentalStatus.EN_ATTENTE:
        return "badge-info";
      case RentalStatus.A_LIVRER:
        return "badge-primary";
      case RentalStatus.ACTIF:
        return "badge-success";
      case RentalStatus.TERMINE:
        return "badge-secondary";
      case RentalStatus.DATE_DEPASSEE:
        return "badge-danger";
      case RentalStatus.ATTENTE_FIN:
        return "badge-warning";
      default:
        return "badge-secondary";
    }
  }

  getStatusLabel(status) {
    switch (status) {
      case RentalStatus.EN_ATTENTE:
        return "À traiter";
      case RentalStatus.A_LIVRER:
        return "À livrer";
      case RentalStatus.ACTIF:
        return "Actif";
      case RentalStatus.TERMINE:
        return "Terminé";
      case RentalStatus.DATE_DEPASSEE:
        return "Date dépassée";
      case RentalStatus.ATTENTE_FIN:
        return "Fin demandée";
      default:
        return "Inconnu";
    }
  }

  formatPrice(price) {
    if (!price && price !== 0) return "-";
    return parseFloat(price).toFixed(2) + "€";
  }

  calculateMonthlyPrice(rental) {
    const now = new Date();
    const selectedMonth = now.getMonth() + 1;
    const selectedYear = now.getFullYear();

    if (!rental.start_date) return 0;

    const startDate = new Date(rental.start_date);
    const endDate = rental.end_date ? new Date(rental.end_date) : null;

    const firstDayOfMonth = new Date(selectedYear, selectedMonth - 1, 1);
    const lastDayOfMonth = new Date(selectedYear, selectedMonth, 0);

    const effectiveStartDate =
      startDate > firstDayOfMonth ? startDate : firstDayOfMonth;
    const effectiveEndDate =
      endDate && endDate < lastDayOfMonth ? endDate : lastDayOfMonth;

    if (effectiveStartDate > lastDayOfMonth || effectiveEndDate < firstDayOfMonth) {
      return 0;
    }

    const diffTime = Math.abs(effectiveEndDate - effectiveStartDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

    const dailyPrice =
      rental.daily_price && !isNaN(parseFloat(rental.daily_price))
        ? parseFloat(rental.daily_price)
        : rental.product &&
          rental.product.prix_u_ht_emera != null &&
          !isNaN(parseFloat(rental.product.prix_u_ht_emera))
        ? parseFloat(rental.product.prix_u_ht_emera)
        : 0;

    return diffDays * dailyPrice;
  }

  render() {
    const { rentals, limit, user } = this.props;
    const rentalsList =
      rentals && rentals.rentals ? rentals.rentals : [];

    // Trier par date de création (les plus récentes en premier) et limiter
    const sortedRentals = [...rentalsList]
      .sort((a, b) => {
        const dateA = new Date(a.created_at || a.start_date);
        const dateB = new Date(b.created_at || b.start_date);
        return dateB - dateA;
      })
      .slice(0, limit || 5);

    if (sortedRentals.length === 0) {
      return (
        <div className="text-center p-3">
          <p className="text-muted">Aucune location trouvée</p>
        </div>
      );
    }

    const isAdmin = user && (user.role === Roles.ADMIN || user.role === Roles.SALES_REP);

    return (
      <table className="table tablee4coll">
        <thead>
          <tr>
            {isAdmin && <th>Établissement</th>}
            <th>Produit</th>
            <th>Date début</th>
            <th>Statut</th>
            <th>Prix journalier</th>
            <th>Prix période mensuelle</th>
          </tr>
        </thead>
        <tbody>
          {sortedRentals.map((rental, index) => {
            const dailyPrice =
              rental.daily_price && !isNaN(parseFloat(rental.daily_price))
                ? parseFloat(rental.daily_price)
                : rental.product &&
                  rental.product.prix_u_ht_emera != null &&
                  !isNaN(parseFloat(rental.product.prix_u_ht_emera))
                ? parseFloat(rental.product.prix_u_ht_emera)
                : null;

            const monthlyPrice = this.calculateMonthlyPrice(rental);

            return (
              <tr key={index}>
                {isAdmin && (
                  <td>{rental.establishment?.name || "Non renseigné"}</td>
                )}
                <td>
                  {rental.product?.designation || rental.product?.ref || "Non renseigné"}
                </td>
                <td>
                  {rental.start_date
                    ? DateUtil.toDate(rental.start_date)
                    : "Non précisée"}
                </td>
                <td>
                  <span
                    className={`badge ${this.getStatusBadgeClass(rental.status)}`}
                  >
                    {this.getStatusLabel(rental.status)}
                  </span>
                </td>
                <td>
                  {dailyPrice !== null ? this.formatPrice(dailyPrice) : "A compléter"}
                </td>
                <td>
                  {this.formatPrice(monthlyPrice)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    rentals: state.rentals || {},
    user: state.user,
  };
};

export default withRouter(connect(mapStateToProps)(RentalsAdmin));
